<p-accordion [id]="id" [activeIndex]="collapsed ? null : 0">
    <p-accordionTab (selectedChange)="selectedChange($event)">
        <ng-template pTemplate="header">
            @if (!headerTemplate) {
                {{ headerTitle }}
            }
            <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
        </ng-template>

        <ng-template pTemplate="content"> <ng-content></ng-content></ng-template>

        <ng-template pTemplate="icon" let-context>
            @if (!context) {
                <i class="fa-regular fa-chevron-down"></i>
            } @else {
                <i class="fa-regular fa-chevron-up"></i>
            }
        </ng-template>
    </p-accordionTab>
</p-accordion>
